import React, { useEffect } from "react";
import HeaderBar from "./common/HeaderBar";
import FooterBar from "./common/FooterBar";
import "../style/about.scss";
import terms from "../image/terms.jpg";

const Terms = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <React.Fragment>
      <HeaderBar />
      <div className="mx-auto max-w-[950px] space-y-8 px-6 py-16 text-[15px] leading-8 text-[#2a2a2a]">
        <p className="text-[30px] font-semibold uppercase tracking-[2px]">
          Terms & Conditions
        </p>

        <p className="text-[14px] text-[#777]">Effective Date: 05/20/2026</p>

        <p>
          These Terms & Conditions outline the rules, expectations, and
          limitations related to the use of this website and any services,
          products, features, or content offered through it. By continuing to
          browse, interact with, or make purchases from this website, you
          acknowledge that you have read, understood, and agreed to these Terms.
        </p>

        <p>
          Our platform was built to offer a modern shopping experience focused
          on simplicity, visual inspiration, and reliable service. To maintain a
          safe and fair environment for all visitors, we ask every user to use
          the website in a lawful and respectful manner.
        </p>

        <div>
          <p className="mb-3 text-[22px] font-medium">1. Website Access</p>

          <p>
            Access to this website is provided on a temporary and non-exclusive
            basis. We reserve the right to withdraw, suspend, limit, or modify
            any part of the website without prior notice. Certain features,
            collections, or services may only be available in selected countries
            or regions.
          </p>

          <p className="mt-4">
            We may occasionally perform maintenance updates, security
            improvements, or technical adjustments that could temporarily affect
            availability or performance.
          </p>
        </div>

        <div>
          <p className="mb-3 text-[22px] font-medium">2. Product Information</p>

          <p>
            We aim to provide accurate descriptions, measurements, images, and
            product details. However, minor differences may occur due to
            photography lighting, screen calibration, material texture, or
            manufacturing updates.
          </p>

          <p className="mt-4">
            Product availability is not guaranteed. Items may be discontinued,
            restocked, updated, or removed at any time without notice.
          </p>

          <p className="mt-4">
            Some products displayed on the website may include lifestyle imagery
            or decorative props that are not included with the purchased item
            unless specifically stated.
          </p>
        </div>

        <div>
          <p className="mb-3 text-[22px] font-medium">
            3. Customer Responsibilities
          </p>

          <p>
            By using this website, you agree not to engage in behavior that may
            harm the website, interfere with its operation, or negatively impact
            other users. This includes unauthorized access attempts, fraudulent
            activity, automated scraping, malicious software distribution, or
            misuse of website content.
          </p>

          <p className="mt-4">
            You are responsible for ensuring that all information submitted
            during checkout, registration, or communication is accurate and
            complete.
          </p>
        </div>

        <div>
          <p className="mb-3 text-[22px] font-medium">
            4. Orders & Payment Verification
          </p>

          <p>
            All orders are subject to review and approval. We reserve the right
            to cancel or refuse any order that appears suspicious, violates
            these Terms, contains inaccurate pricing, or cannot be processed due
            to inventory or payment issues.
          </p>

          <p className="mt-4">
            In some cases, additional payment verification may be required
            before an order is shipped. Failure to provide requested
            verification information may result in cancellation.
          </p>

          <p className="mt-4">
            Prices, discounts, and promotional campaigns may change at any time
            without prior notice.
          </p>
        </div>

        <div>
          <p className="mb-3 text-[22px] font-medium">5. Shipping Conditions</p>

          <p>
            Estimated delivery times are provided for reference only and may
            vary depending on destination, carrier conditions, customs
            procedures, weather, and seasonal demand.
          </p>

          <p className="mt-4">
            Once an order has been transferred to the shipping carrier,
            responsibility for transit handling belongs to the logistics
            provider. Delays caused by shipping carriers are outside of our
            direct control.
          </p>

          <p className="mt-4">
            Customers are responsible for monitoring tracking updates and
            ensuring packages can be safely received at the delivery address
            provided.
          </p>
        </div>

        <div>
          <p className="mb-3 text-[22px] font-medium">
            6. Returns & Refund Decisions
          </p>

          <p>
            Return requests may be accepted according to our return policy
            guidelines. Returned products must generally be unused, undamaged,
            and returned in original condition unless otherwise approved.
          </p>

          <p className="mt-4">
            We reserve the right to deny refund requests involving excessive
            abuse, unusual return patterns, intentionally damaged items, or
            policy manipulation.
          </p>

          <p className="mt-4">
            Shipping costs, customs fees, or handling charges may be
            non-refundable depending on the circumstances of the return.
          </p>
        </div>

        <div>
          <p className="mb-3 text-[22px] font-medium">
            7. Intellectual Property Rights
          </p>

          <p>
            All visual materials, logos, layouts, graphics, icons, product
            names, videos, written descriptions, and creative assets displayed
            on this website remain protected by copyright, trademark, and
            intellectual property laws.
          </p>

          <p className="mt-4">
            No portion of the website may be copied, reproduced, distributed,
            republished, or commercially reused without prior written
            permission.
          </p>
        </div>

        <div>
          <p className="mb-3 text-[22px] font-medium">
            8. Reviews & Community Submissions
          </p>

          <p>
            By submitting reviews, comments, feedback, images, or other
            user-generated content, you grant us a non-exclusive right to
            display, reproduce, edit, or publish that content for marketing,
            promotional, or operational purposes.
          </p>

          <p className="mt-4">
            We reserve the right to remove submissions containing offensive
            language, misleading information, spam, fake reviews, unlawful
            material, or content that violates the rights of others.
          </p>
        </div>

        <div>
          <p className="mb-3 text-[22px] font-medium">
            9. Privacy & Data Handling
          </p>

          <p>
            Certain information may be collected when you interact with the
            website, including browsing activity, device information, purchase
            history, and customer support communications. This information helps
            us improve user experience, prevent fraud, and optimize services.
          </p>

          <p className="mt-4">
            We do not sell sensitive payment information. Payment transactions
            are processed through secure third-party providers.
          </p>
        </div>

        <div>
          <p className="mb-3 text-[22px] font-medium">
            10. Limitation of Liability
          </p>

          <p>
            To the fullest extent permitted by applicable law, we shall not be
            liable for indirect, incidental, special, or consequential damages
            related to the use of this website, delayed shipments, unavailable
            products, technical interruptions, or third-party service failures.
          </p>

          <p className="mt-4">
            Your use of the website is entirely at your own discretion and risk.
          </p>
        </div>

        <div>
          <p className="mb-3 text-[22px] font-medium">
            11. Restricted Activities
          </p>

          <p>
            Users may not use the website for unlawful activities, abusive
            conduct, unauthorized commercial purposes, or actions intended to
            manipulate pricing, inventory systems, promotions, or customer
            reviews.
          </p>

          <p className="mt-4">
            We reserve the right to permanently restrict access to users who
            violate these Terms or engage in suspicious activity.
          </p>
        </div>

        <div>
          <p className="mb-3 text-[22px] font-medium">
            12. Changes To These Terms
          </p>

          <p>
            These Terms may be revised periodically to reflect operational
            changes, legal updates, or service improvements. Continued use of
            the website after changes are published constitutes acceptance of
            the updated Terms.
          </p>
        </div>

        <div>
          <p className="mb-3 text-[22px] font-medium">13. Final Statement</p>

          <p>
            We appreciate every visitor, customer, and supporter who chooses to
            shop with us. Our goal is to create a smooth, secure, and enjoyable
            experience while maintaining fairness, transparency, and respect
            across the platform.
          </p>
        </div>
      </div>
      <FooterBar />
    </React.Fragment>
  );
};

export default Terms;
